// 등록형 위젯 키별 저작 안내(동작 조건 인과) — 위젯 키를 보이는 **모든 표면**이 같은 함수로 낸다.
// 종전엔 소스 필드 표의 '위젯 키' select에만 인라인 분기가 있었고 트리 등록형 위젯 패널에는 없어
// 같은 위젯이 표면에 따라 안내가 있다/없다로 갈렸다(2026-09-14 은닉 감사 3차 B). 문구 자체는 rc
// 사전이 소유한다(IMPROVEMENT_IMAGE_HOST_HINT — 표면별 문구 사본 금지).

import { IMPROVEMENT_IMAGE_HOST_HINT, IMPROVEMENT_IMAGE_WIDGET_KEY } from '@safetyhub/report-composer';

/**
 * 위젯 키의 동작 조건 안내 — 없으면 null. 새 등록형 위젯이 호스트 주입 같은 **보이지 않는 조건**을
 * 가지면 여기에 키를 더한다(riskInjectionHint는 키가 아니라 트리 상태로 판정하는 별도 축).
 */
export function registeredWidgetKeyHint(widgetKey: string | undefined): string | null {
  if (widgetKey === IMPROVEMENT_IMAGE_WIDGET_KEY) return IMPROVEMENT_IMAGE_HOST_HINT;
  return null;
}
